import React, { useRef, useState, useEffect, memo } from 'react';
import Plyr from "plyr-react";

const VideoMediaPlayer = ({ source, setOnload }: any) => {
  const playerRef = useRef<any>(null);
  const [videoBlobURL, setVideoBlobURL] = useState<string>("");
  const [isVideoBlobCreated, setIsVideoBlobCreated] = useState<boolean>(false);

  useEffect(() => {
    const urlToBlob = async () => {
      const blob: any = await fetch(source).then(r => r.blob());
      setVideoBlobURL(URL.createObjectURL(blob));
      setIsVideoBlobCreated(true);
    };
    urlToBlob();
  }, []);

  useEffect(() => {
    if (videoBlobURL !== "" && isVideoBlobCreated) {
      setOnload(false);
    }
  }, [playerRef.current, videoBlobURL, isVideoBlobCreated]);
  
  return (
    <Plyr
      ref={playerRef}
      source={{
        type: "video",
        sources: [
          {
            src: videoBlobURL
          },
        ]
      }}
    />
  );
};

export default memo(VideoMediaPlayer);
